var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-table',{attrs:{"items":_vm.opmerkingen,"fields":[{ key: 'Selectie', label: '' }, 'Type', 'Opmerking']},scopedSlots:_vm._u([{key:"cell(Selectie)",fn:function(row){return [_c('b-check',{model:{value:(row.item.selected),callback:function ($$v) {_vm.$set(row.item, "selected", $$v)},expression:"row.item.selected"}})]}}])}),_c('b-button',{staticClass:"pull-right",attrs:{"disabled":_vm.geselecteerd.length == 0,"size":"sm","variant":"danger"},on:{"click":_vm.opmerkingenVerwijderen}},[_vm._v("\n    Verwijderen\n  ")]),_c('b-form-group',{staticClass:"my-5",attrs:{"label":"Nieuwe opmerking"}},[_c('b-input-group',{attrs:{"prepend":"Type"}},[_c('b-input-group-prepend',[_c('b-select',{attrs:{"options":[
            {
              value: 'OH',
              text: 'OH: Onderhoud'
            }, 
            {
              value: 'OF',
              text: 'OF: Offerte'
            }, 
            {
              value: 'PR',
              text: 'PR: Bedrag in prognose'
            }, 
            {
              value: 'PLOH',
              text: 'PLOH: Planmatig onderhoud'
            }, 
            {
              value: 'KL',
              text: 'KL: Klant'
            },
            {
              value: 'NB',
              text: 'NB: Niet bekend'
            }
          ]},model:{value:(_vm.item.Type),callback:function ($$v) {_vm.$set(_vm.item, "Type", $$v)},expression:"item.Type"}})],1),_c('b-input',{attrs:{"placeholder":"Opmerking"},model:{value:(_vm.item.Opmerking),callback:function ($$v) {_vm.$set(_vm.item, "Opmerking", $$v)},expression:"item.Opmerking"}}),_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.opmerkingToevoegen}},[_vm._v("\n        Toevoegen\n      ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }